import { Injectable } from '@angular/core';
import { ApiService} from '../../../../core/service/api.service';
import { Observable} from 'rxjs/Observable';

@Injectable()
export class ElementCacheService {

  constructor(private api: ApiService) { }

  getElementCacheEntries (search: any): Observable <any>{
      return this.api.get('vna/cache/'+search.cache_type+'/element', {element: search.element});
  }

  getElementCacheEntry (entry : any): Observable <any>{
      return this.api.get('vna/cache/'+entry.type+'/element-entry', {key:entry.key,element:entry.element});
  }

  removeElementCacheEntry(entry : any): Observable <any> {
      return this.api.remove('vna/cache/'+entry.type+'/element-entry',null,{key:entry.key,element:entry.element});
  }

  removeElementCacheEntriesFromFile( data: any, type: string){
      //return this.api.req('POST','vna/cache/phone/file-entry',formData);
      return this.api.post('vna/cache/'+type+'/file-entry',data)

  }


}






// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/services/element-cache.service.ts